import { isLocal } from '../utils/common';
const rejectionReason = response => Promise.reject(new Error(`Failed transaction with status :${response ? response.status : 'unknown'}`));
export const getUrl = (url, path = window.location.pathname) => {
  if (path.startsWith('/hs/email-subscriptions')) {
    return `/hs/email-subscriptions/api${url}`;
  } else if (!isLocal()) {
    return url;
  }
  return `https://api.hubspotqa.com${url}`;
};
const http = {
  get: async url => {
    const apiURL = getUrl(url);
    const response = await fetch(apiURL);
    if (!response.ok) {
      return rejectionReason(response);
    }
    return response.json();
  },
  post: async (url, body) => {
    var _response$headers$get;
    const apiURL = getUrl(url);
    const response = await fetch(apiURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    });
    if (!response.ok) {
      return rejectionReason(response);
    }
    if ((_response$headers$get = response.headers.get('content-type')) !== null && _response$headers$get !== void 0 && _response$headers$get.includes('application/json')) {
      return response.json();
    }
    return null;
  },
  put: async (url, body) => {
    const apiURL = getUrl(url);
    const response = await fetch(apiURL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    });
    if (!response.ok) {
      return rejectionReason(response);
    }
    return response.json();
  }
};
export default http;